"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemLangDefinition = void 0;
const firestore_1 = require("comodel/firestore");
exports.systemLangDefinition = (0, firestore_1.defineCollection)({
    collectionName: "scenario_lang",
    idKey: "langId",
    queryDefs: {
        list: ({ condition }) => {
            return {
                queryParams: {},
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
